import { t } from 'i18next'
import React from 'react'
import { Text } from '@pandiafi/components'

import { validatePasswords } from './utils'
import { PasswordRequirementItem } from './PasswordRequirementItem'

export const PasswordRequirementSection: React.FC<{
  newPassword: string
  newPasswordAgain: string
}> = ({ newPassword, newPasswordAgain }) => {
  const {
    allRequirementsMet,
    lengthRequirementMet,
    lowercaseRequirementMet,
    uppercaseRequirementMet,
    numberRequirementMet,
    specialCharRequirementMet,
    doesNotContainScandicLetters,
  } = validatePasswords(newPassword, newPasswordAgain)
  if (allRequirementsMet || !newPassword) {
    return null
  }

  return (
    <div>
      <Text element="div" size="l">
        {t('registration:createNewPasswordValidationSectionHeader')}
      </Text>
      <Text element="div" size="s">
        {t('registration:createNewPasswordValidationSectionSubheader')}
      </Text>
      <div className="flex flex-col gap-s mt-s">
        <PasswordRequirementItem
          text={t('registration:createNewPasswordValidationErrorLength')}
          isError={!lengthRequirementMet}
        />
        <PasswordRequirementItem
          text={t('registration:createNewPasswordValidationErrorUppercase')}
          isError={!uppercaseRequirementMet}
        />
        <PasswordRequirementItem
          text={t('registration:createNewPasswordValidationErrorLowercase')}
          isError={!lowercaseRequirementMet}
        />
        <PasswordRequirementItem
          text={t('registration:createNewPasswordValidationErrorNumber')}
          isError={!numberRequirementMet}
        />
        <PasswordRequirementItem
          text={t(
            'registration:createNewPasswordValidationErrorSpecialCharacter'
          )}
          isError={!specialCharRequirementMet}
        />
        {doesNotContainScandicLetters ? null : (
          <PasswordRequirementItem
            text={t(
              'registration:createNewPasswordValidationErrorScandicLetters'
            )}
            isError={!doesNotContainScandicLetters}
          />
        )}
      </div>
    </div>
  )
}
